import {
  AttachCommandAppIconParam,
  AttachCommandAppIconResponse,
  ChangeCommandAppIconParam,
  CreateCommandAppParam,
  InteractiveMessageParam,
  SlashCommandApp,
  UpdateCommandAppParam,
  ValidateDuplicatedAppNameParam,
} from '@@types/Api/Command';
import { SLASH_COMMAND_APP_ID } from '@@types/common';

import { URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';

class CommandAppApi {
  constructor(private api: Api2) {}

  fetchUserIntegrationApps = (): Promise<SlashCommandApp[]> => {
    return this.api.contentsRequester.get(`${URLS.API}/apps`);
  };

  fetchAppById = (appId: SLASH_COMMAND_APP_ID): Promise<SlashCommandApp> => {
    return this.api.contentsRequester.get(`${URLS.API}/apps/${appId}`);
  };

  createIntegrationApp = ({
    name,
    description,
    iconId = 0,
    iconSize = 0,
  }: CreateCommandAppParam): Promise<SlashCommandApp> => {
    return this.api.contentsRequester.post(`${URLS.API}/apps`, {
      name,
      description,
      iconId,
      iconSize,
    });
  };

  updateIntegrationApp = ({ appId, ...params }: UpdateCommandAppParam): Promise<SlashCommandApp> => {
    return this.api.contentsRequester.put(`${URLS.API}/apps/${appId}`, params);
  };

  deleteIntegrationApp = (appId: SLASH_COMMAND_APP_ID): Promise<null> => {
    return this.api.contentsRequester.delete(`${URLS.API}/apps/${appId}`);
  };

  attachIcon = ({ appId, file }: AttachCommandAppIconParam): Promise<AttachCommandAppIconResponse> => {
    const data = new FormData();
    data.append('attach', file);
    return this.api.contentsRequester.post(`${URLS.API}/apps/${appId}/icon`, data);
  };

  changeIcon = ({ appId, iconId, file }: ChangeCommandAppIconParam): Promise<AttachCommandAppIconResponse> => {
    const data = new FormData();
    data.append('attach', file);
    return this.api.contentsRequester.post(`${URLS.API}/apps/${appId}/icon/${iconId}`, data);
  };

  generateToken = (appId: SLASH_COMMAND_APP_ID) => {
    return this.api.contentsRequester.put(`${URLS.API}/apps/${appId}/token`);
  };

  updateIntegrationAppInteractiveMessage = ({ appId, ...params }: InteractiveMessageParam): Promise<void> => {
    return this.api.contentsRequester.post(`${URLS.API}/apps/${appId}/interactive-messages`, params);
  };

  validateDuplicatedIntegrationAppName = ({ name, tenantId }: ValidateDuplicatedAppNameParam): Promise<boolean> => {
    return this.api.contentsRequester.get(`${URLS.API}/tenants/${tenantId}/apps`, {
      params: { name },
    });
  };
}

export default CommandAppApi;
